// Get Facility Custom View Fields (by ViewID; ViewID = 0 for a new view)
export const GET_FACILITY_CUSTOM_VIEW_FIELDS_REQUEST = 'GET_FACILITY_CUSTOM_VIEW_FIELDS_REQUEST';
export const GET_FACILITY_CUSTOM_VIEW_FIELDS_SUCCESS = 'GET_FACILITY_CUSTOM_VIEW_FIELDS_SUCCESS';
export const GET_FACILITY_CUSTOM_VIEW_FIELDS_FAILURE = 'GET_FACILITY_CUSTOM_VIEW_FIELDS_FAILURE';

// Save Facility Custom View
export const SAVE_FACILITY_CUSTOM_VIEW_REQUEST = 'SAVE_FACILITY_CUSTOM_VIEW_REQUEST';
export const SAVE_FACILITY_CUSTOM_VIEW_SUCCESS = 'SAVE_FACILITY_CUSTOM_VIEW_SUCCESS';
export const SAVE_FACILITY_CUSTOM_VIEW_FAILURE = 'SAVE_FACILITY_CUSTOM_VIEW_FAILURE';
export const SAVE_FACILITY_CUSTOM_VIEW_RESET = 'SAVE_FACILITY_CUSTOM_VIEW_RESET';


export const FETCH_SITE_CUSTOM_VIEWS_REQUEST = "FETCH_SITE_CUSTOM_VIEWS_REQUEST";
export const FETCH_SITE_CUSTOM_VIEWS_SUCCESS = "FETCH_SITE_CUSTOM_VIEWS_SUCCESS";
export const FETCH_SITE_CUSTOM_VIEWS_FAILURE = "FETCH_SITE_CUSTOM_VIEWS_FAILURE";
export const TOGGLE_SITE_CUSTOM_VIEW_REQUEST = "TOGGLE_SITE_CUSTOM_VIEW_REQUEST";
export const TOGGLE_SITE_CUSTOM_VIEW_SUCCESS = "TOGGLE_SITE_CUSTOM_VIEW_SUCCESS";
export const TOGGLE_SITE_CUSTOM_VIEW_FAILURE = "TOGGLE_SITE_CUSTOM_VIEW_FAILURE";
export const DELETE_SITE_CUSTOM_VIEW_REQUEST = "DELETE_SITE_CUSTOM_VIEW_REQUEST";
export const DELETE_SITE_CUSTOM_VIEW_SUCCESS = "DELETE_SITE_CUSTOM_VIEW_SUCCESS";
export const DELETE_SITE_CUSTOM_VIEW_FAILURE = "DELETE_SITE_CUSTOM_VIEW_FAILURE";
export const FETCH_SITE_CUSTOM_VIEW_DATA_REQUEST = "FETCH_SITE_CUSTOM_VIEW_DATA_REQUEST";
export const FETCH_SITE_CUSTOM_VIEW_DATA_SUCCESS = "FETCH_SITE_CUSTOM_VIEW_DATA_SUCCESS";
export const FETCH_SITE_CUSTOM_VIEW_DATA_FAILURE = "FETCH_SITE_CUSTOM_VIEW_DATA_FAILURE";

// Fetch Site Custom View Share Dropdown (in ShareFacilityCustomViewModal)
export const FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST = "FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST";
export const FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS = "FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS";
export const FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE = "FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE";

// Save Shared Site Custom View
export const SAVE_SHARED_SITE_CUSTOM_VIEW_REQUEST = "SAVE_SHARED_SITE_CUSTOM_VIEW_REQUEST";
export const SAVE_SHARED_SITE_CUSTOM_VIEW_SUCCESS = "SAVE_SHARED_SITE_CUSTOM_VIEW_SUCCESS";
export const SAVE_SHARED_SITE_CUSTOM_VIEW_FAILURE = "SAVE_SHARED_SITE_CUSTOM_VIEW_FAILURE";
